import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { spotFormBunja } from '../bunja/form';
import LimitPriceForm from './LimitPriceForm';
import MarketPriceForm from './MarketPriceForm';
import TriggerPriceForm from './TriggerPriceForm';

const PriceForm = () => {
  const { priceTypeAtom } = useBunja(spotFormBunja);

  const priceType = useAtomValue(priceTypeAtom);

  if (priceType === 'market') return <MarketPriceForm />;
  if (priceType === 'limit') return <LimitPriceForm />;

  return <TriggerPriceForm />;
};

export default PriceForm;
